import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

const Breadcrumbs = ({ paths = [] }) => {
  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs-content">
        <Link to="/dashboard" className="breadcrumbs-home" aria-label="Dashboard">
          <img className="iconlybulkhome" alt="Home" src="/icons/Home.svg" />
        </Link>
        {paths.map((item, idx) => (
          <React.Fragment key={idx}>
            <div className="breadcrumbs-separator">/</div>
            {item.path ? (
              <Link to={item.path} className="breadcrumbs-page breadcrumbs-link">
                {item.label}
              </Link>
            ) : (
              <div className={`breadcrumbs-page${idx === paths.length - 1 ? ' breadcrumbs-current' : ''}`}>
                {item.label}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs; 